<template>
  <section class="ugc-flip-image-control text-center">
    <button
      @click="flipVerticalClick"
      :class="['icon icon-flip', { activate: flippedVertical }]"
    ></button>
    <button
      @click="flipHorizontalClick"
      :class="['icon icon-flip icon-flipped', { activate: flippedHorizontal }]"
    ></button>
  </section>
</template>

<script>
import BaseUgcTool from "../BaseUgcTool";

export default {
  extends: BaseUgcTool,
  name: "UgcFlipImageControl",
  data() {
    return {
      controlName: "flip",
      flipHorizontalOrientation: "",
      flipVerticalOrientation: ""
    };
  },
  computed: {
    fabricCanvas() {
      return this.$store.state.ugc.stateManager.canvas;
    },
    flippedVertical() {

      return this.flipVerticalOrientation === "vertical";
    },
    flippedHorizontal() {
      return this.flipHorizontalOrientation === "horizontal";
    }
  },
  methods: {
    flipVerticalClick() {
      const img = this.fabricCanvas.getObjects("image")[0];
      if (this.flipVerticalOrientation === "vertical") {
        img.set("flipX", false);
        this.flipVerticalOrientation = "";
      } else {
        img.set("flipX", true);
        this.flipVerticalOrientation = "vertical";
      }
      this.fabricCanvas.requestRenderAll();
    },
    flipHorizontalClick() {
      const img = this.fabricCanvas.getObjects("image")[0];
      if (this.flipHorizontalOrientation === "horizontal") {
        img.set("flipY", false);
        this.flipHorizontalOrientation = "";
      } else {
        img.set("flipY", true);
        this.flipHorizontalOrientation = "horizontal";
      }
      this.fabricCanvas.requestRenderAll();
    }
  }
};
</script>
